/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import TransactionalMessageForm from 'cio/components/transactional/message-form';

interface TransactionalMessageFormActionsArgs {
  validations: TransactionalMessageForm['validations'];
  onClose?: () => unknown;
  readOnly: boolean;
  saveButtonText: string;
}

export default class TransactionalMessageFormActions extends Component<TransactionalMessageFormActionsArgs> {}
